class ScrollImage extends HTMLElement {
  constructor() {
    super();

    this.firstImage = this.querySelectorAll(".scroll-image__image")[0];
    this.secondImage = this.querySelectorAll(".scroll-image__image")[1];
    this.thirdImage = this.querySelectorAll(".scroll-image__image")[2];

    window.addEventListener(
      "scroll",
      () => {
        const sectionSeen = percentageSeen(this);
        if (this.firstImage) {
          this.firstImage.style.top = sectionSeen / 1.5 + "%";
        }
        if (this.secondImage) {
          this.secondImage.style.bottom = sectionSeen / 1.5 + "%";
        }
        if (this.thirdImage) {
          this.thirdImage.style.top = sectionSeen / 2.5 + "%";
        }
      },
      { passive: true }
    );
  }
}

customElements.define("scroll-image", ScrollImage);
